/**
 * Article rédigé le 2026-09-06 à partir de sources web ouvertes et vérifiées automatiquement
 * (7 URL testées, révisé après re-vérification). Daté au moment des faits : 2026-06-29.
 * Aucun compte rendu de la journée n'ayant été publié, le texte s'en tient au programme annoncé.
 * À relire avant/après mise en ligne. Format : voir src/blog/README.md
 */
export default {
  "slug": "fete-innovation-2026-french-tech-besancon",
  "title": "Fête de l'innovation 2026 : dix pitchs et une communauté French Tech Besançon",
  "excerpt": "Le 26 juin, la Fête de l'innovation mettait dix pitchs de start-up à l'affiche à l'Espace Grammont, avec, au programme d'ouverture, l'annonce officielle de la labellisation de la Communauté French Tech Besançon.",
  "seoTitle": "Fête de l'innovation 2026 : les dix pitchs",
  "seoDescription": "Au programme de la Fête de l'innovation, le 26 juin 2026 à l'Espace Grammont de Besançon : dix pitchs de start-up et la labellisation French Tech Besançon.",
  "category": "evenements",
  "tags": [
    "Fête de l'innovation",
    "French Tech Besançon",
    "Silicon Comté",
    "Fabrique Numérique Besançon",
    "Espace Grammont"
  ],
  "author": "jimmy",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29",
  "featured": false,
  "cover": {
    "image": "/img/blog/unsplash-1505373877841-8d25f7d46678.jpg",
    "credit": "Photo d'illustration : Teemu Paananen / Unsplash (Unsplash License)",
    "alt": "Photo d'illustration : un intervenant présente son projet sur scène devant un grand écran de diapositives, face à un public assis dans une salle plongée dans la pénombre."
  },
  "content": [
    {
      "type": "lead",
      "text": "La Fête de l'innovation s'est tenue à Besançon le vendredi 26 juin, de 13 heures à 18 heures, à l'Espace Grammont, 20 rue Mégevand[^1][^2]. Au programme annoncé par les organisateurs : les pitchs de dix start-up du territoire[^1], devant un public attendu d'entreprises, de laboratoires de recherche et d'organismes de formation[^2][^3]. Et, au discours d'ouverture, l'annonce officielle de la labellisation de la Communauté French Tech Besançon[^2]. Aucun compte rendu de la journée n'a été publié à ce jour : ce qui suit s'en tient au programme diffusé avant l'événement."
    },
    {
      "type": "keyfacts",
      "title": "En bref",
      "cite": "[^1][^2]",
      "facts": [
        {
          "label": "Quoi",
          "value": "Fête de l'innovation 2026 : pitchs de dix start-up, table ronde, pitchs institutionnels et rendez-vous d'affaires"
        },
        {
          "label": "Quand",
          "value": "Vendredi 26 juin 2026, de 13 h à 18 h"
        },
        {
          "label": "Où",
          "value": "Espace Grammont (Centre diocésain), 20 rue Mégevand, Besançon"
        },
        {
          "label": "Qui",
          "value": "Fabrique Numérique Besançon, Silicon Comté, AER BFC, Village by CA, DECA BFC et La French Tech BFC, avec Grand Besançon Métropole et la Région"
        },
        {
          "label": "Pour qui",
          "value": "Start-up, entreprises, laboratoires et porteurs de projets ; entrée gratuite sur inscription obligatoire"
        }
      ]
    },
    {
      "type": "h2",
      "text": "Un après-midi découpé en quatre temps"
    },
    {
      "type": "p",
      "text": "Le format, reconduit d'une année sur l'autre, tient en une demi-journée dense. Le [programme officiel](https://fete-innovation.make-an-event.com/fr/presentation) publié par les organisateurs déroulait la séquence suivante[^1][^7] :"
    },
    {
      "type": "ul",
      "items": [
        "**13 h – 13 h 30** : accueil et discours d'ouverture des financeurs, Grand Besançon Métropole et la Région Bourgogne-Franche-Comté, ainsi que des six structures organisatrices[^1] ;",
        "**13 h 30 – 14 h 30** : pitchs de dix start-up, invitées à raconter leur parcours, les défis surmontés et leurs besoins actuels[^1][^7] ;",
        "**14 h 30 – 15 h 15** : table ronde « Recherche publique, entrepreneuriat et entreprises numériques : quelles synergies ? »[^1] ;",
        "**15 h 30 – 16 h 30** : pitchs des partenaires institutionnels et des acteurs de l'accompagnement, de l'innovation et de la formation[^1] ;",
        "**16 h 30 – 18 h** : clôture et networking — « buffet et networking » selon macommune.info[^1][^2]. En parallèle, un espace de rendez-vous d'affaires (BtoB) devait rester ouvert de 14 h à 17 h selon l'agenda en ligne[^1]."
      ]
    },
    {
      "type": "h2",
      "text": "Dix pitchs, une scène ouverte"
    },
    {
      "type": "p",
      "text": "Le programme publié ne mentionne ni palmarès ni remise de prix ; l'agenda de l'événement présente la séquence comme une « scène ouverte à l'innovation », sans dimension de concours[^1]. Les dix entreprises étaient invitées à présenter leurs projets et leurs solutions, en insistant autant sur les obstacles rencontrés que sur leurs besoins du moment[^1]. Le format assume ainsi une fonction d'appariement plutôt que de compétition : en parallèle des prises de parole, un espace de rendez-vous d'affaires (BtoB) devait rester ouvert tout au long de l'après-midi pour rencontrer les organismes présents[^1][^3]."
    },
    {
      "type": "p",
      "text": "La liste nominative des dix start-up n'a pas été publiée. Le site de l'événement ne recense, sous l'onglet « Partenaires & Start-Ups », que les huit partenaires exposants — AER BFC, DECA BFC, Fabrique Numérique Besançon, Grand Besançon Métropole, La French Tech BFC, Le Village by CA Besançon, Région Bourgogne-Franche-Comté et Silicon Comté — sans aucun nom de start-up[^1]. Impossible, donc, d'en dresser l'inventaire sans approximation."
    },
    {
      "type": "h2",
      "text": "Laboratoires et entreprises : la table ronde du milieu d'après-midi"
    },
    {
      "type": "p",
      "text": "Annoncée comme animée par Sylvain Compagnon (DECA BFC), la table ronde devait mettre en lumière les interactions entre laboratoires de recherche, start-up et entreprises du numérique[^1]. Le sujet est moins abstrait qu'il n'y paraît dans un bassin universitaire comme celui de Besançon : le programme prévoyait de présenter les expertises scientifiques du territoire, le rôle des acteurs de la valorisation et les différentes formes de collaboration possibles — partenariats, transferts de technologies, expérimentations et accès aux plateformes[^1]."
    },
    {
      "type": "h2",
      "text": "Ce que recouvre le label « French Tech Besançon »"
    },
    {
      "type": "p",
      "text": "L'annonce inscrite au programme d'ouverture[^2] s'insère dans un mouvement plus large. [Le réseau des Capitales et Communautés French Tech 2026-2028](/blog/french-tech-bfc-capitale-2026-2028-besancon) a été dévoilé par la Mission French Tech en mai 2026 : 19 Capitales et 28 Communautés labellisées en France, aux côtés de 78 Communautés à l'international dans 57 pays, pour 1 100 bénévoles et 3 000 start-up fédérées[^4]. La French Tech Besançon figure bien dans la liste des 28 Communautés françaises annexée au dossier de presse ministériel[^5]."
    },
    {
      "type": "p",
      "text": "Le dossier de presse ne mentionne aucune contrepartie financière attachée au label : il décrit les Communautés comme des collectifs structurés et autonomes, fédérant les acteurs locaux autour d'une stratégie commune, et en fait « le premier maillon » du réseau national, porté par l'engagement bénévole — 1 100 personnes à l'échelle du réseau[^5]. Reste à savoir qui animera la structure bisontine : l'information n'est pas publique à ce stade."
    },
    {
      "type": "p",
      "text": "Besançon ne partait toutefois pas de rien. La French Tech Bourgogne-Franche-Comté, renouvelée Capitale French Tech pour 2026-2028, décrivait déjà en mai un maillage couvrant Dijon, Besançon, le Nord Franche-Comté, Mâcon, Nevers et Auxerre[^4]. L'association parlait alors d'« une reconnaissance collective pour l'écosystème régional »[^4]. La labellisation nationale, actée dès mai 2026[^5], donne à ce relais bisontin un statut identifié, dans un cadre régional dont la feuille de route 2026-2028 s'articule autour de quatre priorités : stimuler le dealflow entrepreneurial, accélérer l'accès au financement, développer les marchés et lever les freins structurels[^4]."
    },
    {
      "type": "callout",
      "tone": "tip",
      "title": "Pourquoi ça compte pour Besançon",
      "text": "Un label ne crée ni emploi ni chiffre d'affaires. Ce qu'il change, c'est la lisibilité : un point d'entrée nommé pour un écosystème réparti jusqu'ici entre plusieurs associations et agences. Pour une start-up bisontine, cela signifie un interlocuteur identifiable au moment de chercher un financeur, un partenaire de recherche ou un premier client public."
    },
    {
      "type": "h2",
      "text": "De la Citadelle à l'Espace Grammont"
    },
    {
      "type": "p",
      "text": "L'édition précédente s'était tenue le 26 juin 2025 à la Citadelle, de 13 h à 17 h, déjà avec dix pitchs de start-up et une table ronde consacrée aux enjeux du numérique associant les pôles de compétitivité régionaux[^6]. En un an, le rendez-vous a gagné une heure, changé de décor pour une salle du centre-ville et élargi son tour de table : la [Fabrique Numérique Besançon](/blog/premiere-pierre-le-numerique-planoise-besancon) et Silicon Comté sont désormais épaulées par l'AER BFC, le Village by CA et DECA BFC, tandis que La French Tech BFC, simple soutien en 2025, figure cette année parmi les organisateurs[^1][^6]."
    },
    {
      "type": "h2",
      "text": "La suite"
    },
    {
      "type": "p",
      "text": "Le prochain jalon régional est déjà fixé : CONNECT, le rendez-vous de l'innovation et de la tech en Bourgogne-Franche-Comté, se tiendra le 22 septembre[^4]. D'ici là, l'intérêt de la journée du 26 juin se mesurera à des signes peu spectaculaires : la publication d'une gouvernance pour la communauté bisontine, un calendrier d'animations, quelques collaborations nées entre deux tables de l'Espace Grammont."
    }
  ],
  "references": [
    {
      "id": 1,
      "title": "Fête de l'innovation 2026 — Présentation et programme",
      "publisher": "Fête de l'innovation 2026 (site officiel)",
      "url": "https://fete-innovation.make-an-event.com/fr/presentation",
      "type": "official",
      "date": "2026-06-26"
    },
    {
      "id": 2,
      "title": "Fête de l'innovation 2026 : le rendez-vous des projets de demain à Besançon",
      "publisher": "macommune.info",
      "url": "https://www.macommune.info/agenda/fete-de-linnovation-2026-le-rendez-vous-des-projets-de-demain-a-besancon/",
      "type": "press",
      "date": "2026-06-12"
    },
    {
      "id": 3,
      "title": "Les start-ups, entreprises et laboratoires se réuniront à la Fête de l'Innovation 2026",
      "publisher": "macommune.info",
      "url": "https://www.macommune.info/les-start-ups-entreprises-et-laboratoires-se-reuniront-a-la-fete-de-linnovation-2026/",
      "type": "press",
      "date": "2026-05-30"
    },
    {
      "id": 4,
      "title": "La French Tech Bourgogne-Franche-Comté renouvelée Capitale French Tech pour 2026-2028 !",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/actualites/ecosysteme/la-french-tech-bourgogne-franche-comte-renouvelee-capitale-french-tech-pour-2026-2028/",
      "type": "official",
      "date": "2026-05-22"
    },
    {
      "id": 5,
      "title": "Dossier de presse — Labellisation des Capitales et Communautés French Tech 2026-2028 (mai 2026)",
      "publisher": "Mission French Tech",
      "url": "https://lafrenchtech.gouv.fr/app/uploads/2026/05/DP_Labellisation-2026-2028_.pdf",
      "type": "official",
      "date": "2026-05"
    },
    {
      "id": 6,
      "title": "Fête de l'innovation 2025",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/nos-evenements/fete-de-linnovation-2025/",
      "type": "official",
      "date": "2025-06-26"
    },
    {
      "id": 7,
      "title": "Fête de l'innovation (page événement 2026)",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/nos-evenements/fete-de-linnovation/",
      "type": "official",
      "date": "2026-06-26"
    }
  ]
};
